import React, { Component } from 'react';
import { connect } from 'formik';
import { IPreferencesProps, IOuterProps } from '../../models/components/preferences';
import {
    SortableContainer,
    SortableElement,
} from 'react-sortable-hoc';
import arrayMove from 'array-move';
import { NotificationIndexBoxType } from '../../models/enums/NotificationIndexBoxType';
import Switch from 'react-switch';
import Translator from '../../core/i18n';
import { Log } from 'ng2-logger';
import { Button } from '../../components/ui-elements/main';

const T = Translator.create();
const _logger = Log.create('User Preferences');
const SortableList = SortableContainer(({ children }: any) => {
    return <div className="col-12 question-list" style={{ padding: 0 }}>{children}</div>;
});

export class Notifications extends Component<IPreferencesProps> {
    state = {
        permission: false,
        checkboxStatus: false,
        boxItems: ['0', '1', '2', '3', '4', '5', '6'],
        dateFormat: [{ value: 'DD.MM.YYYY', label: 'DD.MM.YYYY' }, { value: 'MM.DD.YYYY', label: 'MM.DD.YYYY' }],
        boxVisualRadio: true,
        boxItemsVisual: [false, false, false, false, false, false, false],
        boxAppItems: ['0', '1', '2', '3', '4', '5', '6'],
        boxAppItemsVisual: [false, false, false, false, false, false, false],
        boxAppVisualRadio: true,

    };

    public SortableItem = SortableElement(({ value }: any) => (
        <div style={{ background: 'transparent' }} className="question-row">
            <div className="tick-radio position-relative">
                <input
                    id={'home.index.boxvisual'}
                    type="checkbox"
                    name={'boxVisualRadio'}
                    // tslint:disable-next-line:jsx-no-lambda
                    onChange={e => this.handleInputChange(e, value, 'email')}
                    value={1}
                    checked={this.state.boxItemsVisual[value]}
                    style={{ verticalAlign: 'middle' }}
                    className="form-radio"
                />
                <span style={{ marginLeft: '15px' }}>{this.equalsType(value)}</span>
            </div>
        </div>
    ));


    public SortableAppItem = SortableElement(({ value }: any) => (
        <div style={{ background: 'transparent' }} className="question-row">
            <div className="tick-radio position-relative">
                <input
                    id={'home.index.appboxvisual'}
                    type="checkbox"
                    name={'boxVisualRadio'}
                    // tslint:disable-next-line:jsx-no-lambda
                    onChange={e => this.handleInputChange(e, value, 'app')}
                    value={1}
                    checked={this.state.boxAppItemsVisual[value]}
                    style={{ verticalAlign: 'middle' }}
                    className="form-radio"
                />
                <span style={{ marginLeft: '15px' }}>{this.equalsType(value)}</span>
            </div>
        </div>
    ));

    submitApply = () =>
    {
        if (this.state.checkboxStatus)
        {
            this.setState({permission: true})
        }
    }

    changeApply = (e: any) =>
    {
        let status = false;
        if (e.target.checked)
        {
            status = true;
        }

            this.setState({checkboxStatus: status})
    }

    handleInputChange = (event: any, setValue: any, type: string) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        if (type == 'email')
        {
            this.setState(prevState => ({ boxItemsVisual: {setValue: value} }));
        }
        else
        {
            this.setState(prevState => ({ boxAppItemsVisual: {setValue: value} }));
        }

        this.saveBoxes(type);
    }

    equalsType = (value: any) => {
        switch (value) {
            case NotificationIndexBoxType.Activity:
                return T.t('r_gen_new_activities');
            case NotificationIndexBoxType.Help:
                return T.t('r_help_desk');
            case NotificationIndexBoxType.Completed:
                return T.t('r_gen_latest_completions');
            case NotificationIndexBoxType.VirtualClass:
                return T.t('r_gen_live_lessons');
            case NotificationIndexBoxType.Message:
                return T.t('r_home_index_box_message');
            case NotificationIndexBoxType.Exam:
                return T.t('r_gen_exams');
            case NotificationIndexBoxType.Assignment:
                return T.t('r_gen_assignments');
        }
    }

    onSortEnd = ({ oldIndex, newIndex }: any) => {
        if (oldIndex !== newIndex) {
            this.setState(({ boxItems }: any) => ({
                boxItems: arrayMove(boxItems, oldIndex, newIndex),
            }));
        }

        this.saveBoxes('');
    };

    saveBoxes = (type: any) => {
        setTimeout(() => {
            const boxAllowed: string[] = [];

            if (type == 'app')
            {
                this.state.boxAppItems.forEach(item => {
                    boxAllowed.push(item);
                });

                this.state.boxAppItems.forEach(item => {
                    if (!this.state.boxAppItemsVisual[parseInt(item, 10)]) {
                        boxAllowed.splice(boxAllowed.indexOf(item), 1);
                    }
                });
            }
            else
            {
                this.state.boxItems.forEach(item => {
                    boxAllowed.push(item);
                });

                this.state.boxItems.forEach(item => {
                    if (!this.state.boxItemsVisual[parseInt(item, 10)]) {
                        boxAllowed.splice(boxAllowed.indexOf(item), 1);
                    }
                });
            }
        }, 1000);
    }

    componentDidMount() {
        const items = ['0', '1', '2', '3', '4', '5', '6'];

        items.forEach(item => {
            if (!this.state.boxItems.includes(item)) { this.state.boxItems.push(item); }
        });

    }

    onChangeSwitch = (checked: any, event: any, id: any) => {
        if (id == 'email_notification')
        {
            this.setState({boxVisualRadio: checked})
        }
        else
        {
            this.setState({boxAppVisualRadio: checked})
        }
        this.props.formik.values.handleChangeSwitch(checked, event, id);
    }


    public render() {
        const { boxItems } = this.state;

        return (
            <div className="send-notification">
                {!this.state.permission ?
                <div className='row'>
                    <div className='col-12'>
                    <div className='d-flex justify-content-center align-items-center'>
                        <div><span className="material-icons" style={{fontSize: '32px'}}>
                            info
                            </span></div>
                        <div >{T.t('r_noticication_access_info')}</div>
                        </div>
                        </div>

                   <div className='notification-form' style={{backgroundColor: "#fbfaf6"}}>
                    <div className='form'>
                        <div className='checkbox-apply tick-radio'>
                        <input
                                        type="checkbox"
                                        name="demo"
                                        defaultValue="one"
                                        id="radio-vc"
                                        className="checkbox-radio"
                                        onChange={e => this.changeApply(e)}

                                    />
                            {T.t("r_gen_read_approve")}
                            </div>

                        <div className='mini-btn text-md-right'>
                            <Button text={T.t('r_save_button')} button_type={this.state.checkboxStatus ? 'primary' : 'secondary'} size='medium'onClick={this.submitApply} materialicon='done' />
                        </div>

                        </div>

                    </div>

                </div>


                 :
                 (
                    <div className='col-12' style={{display: "flex", justifyContent: "space-between"}}>
                        <div className='col-6'>
                        <h5 className="mb-3">{T.t('r_gen_e_mail_notifications')}

                        <a id='active_grid' className="tooltip-container " style={{ padding: '1px 8px 5px 8px', cursor: 'pointer', marginRight: 0 }}>
                        <span className="material-icons">
info
</span>
                                <div className="viewType-tooltip" style={{ width: "300px"}}>
                                     <span className="text-white">{T.t('r_e_mail_notification_info')}</span>
                                </div>
                            </a>

                        </h5>

<div className="small-switch mb-4">
    <label className="switch">
        <Switch
            id={'email_notification'}
            name={'boxVisualRadio'}
            onChange={this.onChangeSwitch}
            checked={this.state.boxVisualRadio}
            checkedIcon={false}
            uncheckedIcon={false}
            onColor="#319b6b"
            className="react-switch react-switch-margin"
            height={20}
            width={38}
        />
    </label>
    <span>{T.t('r_gen_get_e_mail_notifications')}</span>
</div>

<div className="mb-3 d-flex align-items-end sortable-list">
    <SortableList disabled={true} onSortEnd={this.onSortEnd}>
        {boxItems.map((value, index) => {
            return <this.SortableItem key={`email-item-${value}`} index={index} value={parseInt(value, 10)} list={this.SortableItem} />;
        })}
    </SortableList>
</div>

                    </div>
                    <div className='col-6'><h5 className="mb-3">{T.t('r_gen_in_app_notifications')}</h5>

<div className="small-switch mb-4">
    <label className="switch">
        <Switch
            id={'app_notification'}
            name={'boxAppVisualRadio'}
            onChange={this.onChangeSwitch}
            checked={this.state.boxAppVisualRadio}
            checkedIcon={false}
            uncheckedIcon={false}
            onColor="#319b6b"
            className="react-switch react-switch-margin"
            height={20}
            width={38}
        />
    </label>
    <span>{T.t('r_gen_get_in_app_notifications')}</span>
</div>

<div className="mb-3 d-flex align-items-end sortable-list">
    <SortableList disabled={true} onSortEnd={this.onSortEnd}>
        {boxItems.map((value, index) => {
            return <this.SortableAppItem key={`app-item-${value}`} index={index} value={parseInt(value, 10)} list={this.SortableAppItem} />;
        })}
    </SortableList>
</div></div>
                    </div>
                 )
                }
            </div >
        );
    }
}

export default connect<{}, IOuterProps>(Notifications);
